import isValidUuid from '@zenbusiness/application-commons-utils/isValidUuid';

/** Kept in sync with assistant-ui `DASHBOARD_RESUME_THREAD_KEY`. */
export const VELO_RESUME_THREAD_KEY = 'velo.dashboard.resumeThreadUuid';

/**
 * One-shot read of the cross-sell handoff resume intent (GROWTH-4719).
 * @returns {string | null}
 */
export function consumeVeloResumeThreadUuid() {
  try {
    const stored = sessionStorage.getItem(VELO_RESUME_THREAD_KEY);
    if (stored !== null) {
      sessionStorage.removeItem(VELO_RESUME_THREAD_KEY);
    }
    return isValidUuid(stored) ? stored : null;
  } catch {
    return null;
  }
}
